import { takeEvery, select, put } from 'redux-saga/effects';
import { createAction, handleActions } from 'redux-actions';
import { actionTypes, isDirty } from 'redux-form';

export const allowLeavingForm = createAction('allowLeaveForm');
export const disableLeavingForm = createAction('disableLeavingForm');

const blacklist = ['filter', 'blocked-ips', 'pinningGroup'];

function* workerFormChange(action: any) {
  const form = action.meta.form;
  if (blacklist.includes(form)) return;
  const isChanged = yield select(isDirty(form));
  if (isChanged) yield put(disableLeavingForm());
}

function* watchFormChange() {
  yield takeEvery(
    [actionTypes.CHANGE, actionTypes.ARRAY_INSERT, actionTypes.ARRAY_MOVE],
    workerFormChange
  );
}

function* watchFormSubmit() {
  yield takeEvery(actionTypes.START_SUBMIT, function* (action: any) {
    yield put(allowLeavingForm());
  });
  yield takeEvery(actionTypes.SET_SUBMIT_SUCCEEDED, function* (action: any) {
    yield put(allowLeavingForm());
  });
}

export const reducer = handleActions(
  {
    [allowLeavingForm]: (s) => ({ ...s, anyFormChanged: false }),
    [disableLeavingForm]: (s) => ({ ...s, anyFormChanged: true }),
  },
  {
    anyFormChanged: false,
  }
);

export const saga = [watchFormChange(), watchFormSubmit()];
